import { render, staticRenderFns } from "./PromptTextDialog.vue?vue&type=template&id=8bffae9a&"
import script from "./PromptTextDialog.vue?vue&type=script&lang=js&"
export * from "./PromptTextDialog.vue?vue&type=script&lang=js&"
import style0 from "./PromptTextDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports